import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cn } from "@/lib/utils";

function UnstyledButton({
	className,
	type = "button",
	...props
}: ButtonPrimitive.Props) {
	return (
		<ButtonPrimitive
			data-slot="button"
			type={type}
			className={cn(
				"block w-full appearance-none border-0 bg-transparent p-0 text-left font-inherit text-inherit",
				className,
			)}
			{...props}
		/>
	);
}

export { UnstyledButton };
